import { EMPTY_PROPOSAL_COPY_FOR_RECAL_SEARCH_CRITERIA } from "domain/entity/ProposalCopyingForRecal/ProposalCopyingForRecalSearchCriteria";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import ProposalCopyingForRecalRightPanel from "./ProposalCopyingForRecalRightPanel";
import ProposalCopyingForRecalSearchPanel from "./ProposalCopyingForRecalSearchPanel";
import ProposalCopyingForRecalTitleBar from "./ProposalCopyingForRecalTitleBar";

const ProposalCopyingForRecalMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();
    const { isShowCriteriaPanel } = proposalCopyingForRecalState;


    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            try {
                let newSearchCriteria = null;
                newSearchCriteria = { ...EMPTY_PROPOSAL_COPY_FOR_RECAL_SEARCH_CRITERIA }
                const standardResults = await Promise.allSettled([
                    proposalCopyingForRecalVM.loadDropdownOption(),
                    proposalCopyingForRecalVM.searchNewProposalsForRecal(),
                    proposalCopyingForRecalVM.searchProposalsForRecal(newSearchCriteria),
                ]);
                standardResults?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then(() => {
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });

    }, [proposalCopyingForRecalVM])





    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${(isShowCriteriaPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <ProposalCopyingForRecalTitleBar />
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowCriteriaPanel ? "25%" : "0%"}
                rightSectionWidth={isShowCriteriaPanel ? "75%" : "100%"}
                leftChildren={<ProposalCopyingForRecalSearchPanel />}
                rightChildren={<ProposalCopyingForRecalRightPanel />}
            />
        </div>
    </>
}

export default memo(ProposalCopyingForRecalMaintenance);